import React, {FunctionComponent, useRef, useState} from "react";
import WizardStep from "../../WizardStep";
import statusShipping from "../../../../images/Progress/progress_versand.svg";
import CheckBox from "../../../../commonComponents/CheckBox";
import {Box, FormControl, Grid, InputLabel, makeStyles, NativeSelect} from "@material-ui/core";
import WeigthInput from "../../../../commonComponents/WeightInput";
import {Step} from "../../../WizardMap";
import FormHelperText from "@material-ui/core/FormHelperText";
import {selectOptions} from "./SelectOptions";
import ValidateTextInput from "../../../../commonComponents/ValidateTextInput";
import {ValidatorForm} from "react-material-ui-form-validator";
import {useDispatch, useSelector, batch} from "react-redux";
import {RootState} from "../../../../redux/rootReducer";
import {
    initialPickUpState,
    setPickUpAddress,
    setPickUpTimespan,
    incrementPickUpWeight,
    decrementPickUpWeight,
    setPickUpDate
} from "../../../state/contactSlice";
import {Address} from "../../../../API";
import moment, {Moment} from "moment";
import DatePicker from "../../../../commonComponents/DatePicker";
import {NavigationProps} from "../../../slideRouter/navigationHook";
import {nextWorkDayInRange} from "../../../state/utils";

const longInputWith: number = 260;

const useStyles = makeStyles(theme => ({
    formContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    gridContainer: {
        margin: 0,
        paddingBottom: 0,
        [theme.breakpoints.down("xs")]: {
            width: "100%"
        }
    },
    shortTextInput: {
        width: (longInputWith / 2) - 10
    },
    longTextInput: {
        width: longInputWith
    },
    longWithContainer: {
        width: longInputWith,
        display: "flex",
        justifyContent: "space-between"
    },
    notificationContainer: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        marginTop: 25,
        [theme.breakpoints.down("xs")]: {
            width: longInputWith,
            marginTop: 20
        }
    },
    checkBoxContainer: {
        width: longInputWith
    }
}));

const StepPickUpInfo: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const classes = useStyles();

    const dispatch = useDispatch();

    const {pickUp} = useSelector((state: RootState) => state.contact);

    const [withDifferingAddress, setWithDifferingAddress] = useState(false);

    const [difAddress, setDifAddress] = useState<Address>({
        name: "",
        lastName: "",
        street: "",
        postalCode: "",
        city: "",
        country: ""
    });

    const formRef = useRef<ValidatorForm | null>(null);

    const handleToggleDifferingPickupAddress = () => {
        formRef.current && formRef.current.resetValidations();
        setWithDifferingAddress(prevState => !prevState);
    };

    const handleFormSubmit = () => {
        if (formRef && formRef.current) {
            formRef.current.isFormValid(false).then(isValid => {
                if (isValid) {
                    batch(() => {
                        withDifferingAddress
                            ? dispatch(setPickUpAddress(difAddress))
                            : dispatch(setPickUpAddress(null));
                        !pickUp && dispatch(setPickUpDate(moment().add(2, "days").toObject()));
                    });
                    gotoNextSlide(Step.PAYMENT);
                }
            });
        }
    };

    return (
        <WizardStep
            title={"Bitte machen Sie folgende Angaben"}
            icon={statusShipping}
            backButton
            onBackClick={gotoPrevSlide}
            nextButton
            onNextClick={handleFormSubmit}
        >
            <ValidatorForm
                ref={formRef}
                onSubmit={() => {
                }}
                className={classes.formContainer}
            >
                <Box className={classes.checkBoxContainer}>
                    <CheckBox
                        text={"Abweichende Abholadresse"}
                        checked={withDifferingAddress}
                        onClick={handleToggleDifferingPickupAddress}
                    />
                </Box>
                {withDifferingAddress &&
                <Box>
                    <Grid
                        container
                        spacing={4}
                        justify={"center"}
                        className={classes.gridContainer}
                    >
                        <Grid item>
                            <ValidateTextInput
                                name="firstName"
                                label={"Vorname"}
                                disabled={!withDifferingAddress}
                                validators={withDifferingAddress ? ["required"] : []}
                                errorMessages={["erforderlich"]}
                                value={difAddress.name}
                                onChangeText={(name: string) => setDifAddress({...difAddress, name})}
                                className={classes.longTextInput}
                            />
                        </Grid>
                        <Grid item>
                            <ValidateTextInput
                                name={"lastName"}
                                label={"Nachname"}
                                disabled={!withDifferingAddress}
                                validators={withDifferingAddress ? ["required"] : []}
                                errorMessages={["erforderlich"]}
                                value={difAddress.lastName}
                                onChangeText={(lastName: string) => setDifAddress({...difAddress, lastName})}
                                className={classes.longTextInput}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={4}
                        justify={"center"}
                        className={classes.gridContainer}
                    >
                        <Grid item>
                            <ValidateTextInput
                                name={"street"}
                                label={"Straße & Hausnummer"}
                                disabled={!withDifferingAddress}
                                validators={withDifferingAddress ? ["required"] : []}
                                errorMessages={["erforderlich"]}
                                value={difAddress.street}
                                onChangeText={(street: string) => setDifAddress({...difAddress, street})}
                                className={classes.longTextInput}
                            />
                        </Grid>
                        <Grid item>
                            <Box className={classes.longWithContainer}>
                                <FormControl>
                                    <ValidateTextInput
                                        name={"postalCode"}
                                        label={"PLZ"}
                                        disabled={!withDifferingAddress}
                                        validators={withDifferingAddress ? ["required", "isNumber"] : []}
                                        errorMessages={["erforderlich", "ungültig"]}
                                        value={difAddress.postalCode}
                                        onChangeText={(postalCode: string) => setDifAddress({
                                            ...difAddress,
                                            postalCode
                                        })}
                                        className={classes.shortTextInput}
                                    />
                                    <FormHelperText/>
                                </FormControl>
                                <FormControl>
                                    <ValidateTextInput
                                        name={"city"}
                                        label={"Stadt"}
                                        disabled={!withDifferingAddress}
                                        validators={withDifferingAddress ? ["required"] : []}
                                        errorMessages={["erforderlich"]}
                                        value={difAddress.city}
                                        onChangeText={(city: string) => setDifAddress({...difAddress, city})}
                                        className={classes.shortTextInput}
                                    />
                                    <FormHelperText/>
                                </FormControl>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>}
                <Box marginTop={4} marginBottom={5}>
                    <WeigthInput
                        weight={pickUp ? pickUp.weight : initialPickUpState.weight}
                        width={longInputWith}
                        onIncrement={() => dispatch(incrementPickUpWeight())}
                        onDecrement={() => dispatch(decrementPickUpWeight())}
                    />
                </Box>
                <DatePicker
                    label={"Abholtermin"}
                    value={(pickUp && pickUp.date) ? moment(pickUp.date) : nextWorkDayInRange(2)}
                    onSelectDate={(date: Moment | null) => dispatch(setPickUpDate(date ? (date as Moment).toObject() : undefined))}
                    shouldDisableDate={(date: Moment | null) => (date as Moment).weekday() === 0 || (date as Moment).weekday() === 6}
                    minDate={moment().add(2, "days")}
                    disablePast
                    inputStyle={{width: longInputWith}}
                />
                <Box className={classes.longWithContainer} marginTop={5}>
                    <FormControl style={{width: "100%"}}>
                        <InputLabel htmlFor="birthday-day" style={{color: "#999"}}>Uhrzeit</InputLabel>
                        <NativeSelect
                            value={pickUp ? pickUp.timespan : initialPickUpState.timespan}
                            style={{color: "#000"}}
                            onChange={event => dispatch(setPickUpTimespan(event.target.value))}
                            inputProps={{
                                name: "pickupTime",
                                id: "pickup-time"
                            }}
                        >
                            {selectOptions.time}
                        </NativeSelect>
                        <FormHelperText/>
                    </FormControl>
                </Box>
            </ValidatorForm>
        </WizardStep>
    );
};

export default StepPickUpInfo;
